import {
  CaptureTreeEntityRevision,
  CaptureTreeEntityType,
  RegistrationRevision,
  RegistrationState,
  RevisionStatus,
  RevisionType,
} from "@faro-lotv/service-wires";

/**
 * @param revision The revision to check.
 * @returns Whether the revision is an open draft revision.
 */
export function isOpenDraftRevision(revision: RegistrationRevision): boolean {
  return (
    revision.revisionType === RevisionType.draft &&
    revision.state !== RegistrationState.merged &&
    revision.state !== RegistrationState.canceled
  );
}

/**
 * @param revision The revision to check.
 * @param entities The entities of the open draft revision to check.
 * @returns Whether the open draft revision has changes.
 */
export function hasDraftChanges(
  revision?: RegistrationRevision,
  entities?: CaptureTreeEntityRevision[],
): boolean {
  if (!revision || !isOpenDraftRevision(revision) || !entities) {
    return false;
  }
  return entities.some(
    (entity) =>
      // The initial creation of root entity should not be considered as a change.
      (entity.type !== CaptureTreeEntityType.root ||
        entity.status !== RevisionStatus.added) &&
      entity.status !== RevisionStatus.initialized,
  );
}
